import React from "react";
import { Box, Card } from "@mui/material";
import { RoleBundle } from "../../types/models/RoleBundle";
import { RoleBundleSkeleton } from "./RoleBundleSkeleton";
import { RoleBundleItem } from "./RoleBundleItem";
import EmptyResult from "../rules/EmptyResult";

interface RoleBundleListProp {
  roleBundles: RoleBundle[] | undefined;
  isLoading: boolean;
  onEditRoleBundle: (bundle: RoleBundle) => void;
}

export const RoleBundleList: React.FC<RoleBundleListProp> = (prop) => {
  const getBundleList = () => {
    if (prop.isLoading) {
      return <RoleBundleSkeleton />;
    } else if (prop.roleBundles && prop.roleBundles.length === 0) {
      return <EmptyResult>No Role Bundles exist</EmptyResult>;
    } else {
      return (
        <Box>
          {prop.roleBundles?.map((roleBundle) => (
            <RoleBundleItem
              key={roleBundle.Id}
              roleBundle={roleBundle}
              onEdit={(roleBundle) => prop.onEditRoleBundle(roleBundle)}
            />
          ))}
        </Box>
      );
    }
  };

  return <Card sx={{ width: "100%" }}>{getBundleList()}</Card>;
};
